import type { FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { SectionCompanyJobs } from './section-company-jobs/section-company-jobs';
import { SectionSimilarJobs } from './section-similar-jobs/section-similar-jobs';

export const JobsModule: FC = () => {
  const { pageContext } = usePageContext();

  return (
    <>
      <SectionCompanyJobs />
      {!pageContext.isEBP && <SectionSimilarJobs />}
    </>
  );
};
